import {cn} from '@sollapay/ui';

import {
  TRUST_ACCOUNT_GRID_CARD_CONTAINER_CLASS,
  TRUST_ACCOUNT_GRID_CARD_GRID_CLASS
} from '../../config';
import {TrustAccountStatusGroupHeaderSkeleton} from '../TrustAccountStatusGroupHeader';
import {TrustAccountGridCardSkeleton} from './TrustAccountGridCard.skeleton';

import type {FC} from 'react';

// An active section above a setup one, as most lists open.
const SECTIONS = [
  {key: 'active', cards: 3, withBalance: true},
  {key: 'setup', cards: 2, withBalance: false}
];

/** Same sections and grid as the loaded card list, so nothing shifts when data arrives. */
export const TrustAccountGridCardListSkeleton: FC = () => (
  <div data-slot="trust-account-grid-card-list-skeleton" className="flex flex-col gap-7">
    {SECTIONS.map(({key, cards, withBalance}) => (
      <div
        key={key}
        className={cn(TRUST_ACCOUNT_GRID_CARD_CONTAINER_CLASS, 'flex flex-col gap-3.5')}
      >
        <TrustAccountStatusGroupHeaderSkeleton variant="section" />
        <div className={TRUST_ACCOUNT_GRID_CARD_GRID_CLASS}>
          {Array.from({length: cards}, (_, index) => (
            <TrustAccountGridCardSkeleton key={index} withBalance={withBalance} />
          ))}
        </div>
      </div>
    ))}
  </div>
);
